/**************************************************
 * Nombre:       Anuncio_Suscribite
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import img_fondo from "../../Recursos/suscribete.png";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../App";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from "../../Recursos/logo_redondo.svg";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Suscripcion from "../Dialogos/Dialogo_Suscripcion";
import Dialogo_Politicas from "../Dialogos/Dialogo_Politicas";
import {theme} from "../../Tema";


const Anuncio_Suscribite = ({cerrar}) => {
    const {sCell, masSM, sTab} = useResponsive()
    const cData = useContext(contexApp)
    const {Avisos, Cargador, iniciarCarga, nuevoAviso, terminar} = useCargador({logoRedondo: logo})
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Suscripcion, realizado: cerrar})
    const {Dialogo: DialogoPol, abrir: abrirPol} = useDialogo({Componente: Dialogo_Politicas})
    const [politicas, setPoliticas] = useState([])


    useEffect(() => {

        if (cData.configuraciones) {
            setPoliticas(cData.configuraciones.politica_protenccion)
        }


    }, [cData.configuraciones]);

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        sx={{color: theme.palette.primary.main}}
        >

            <Cargador/>
            <Avisos/>
            <Dialogo/>
            <DialogoPol/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{ justifyContent: 'center', px: 2}}>
                <Typography
                    sx={{
                        fontFamily: 'Dm Serif Display',
                        fontSize: 32,
                        fontWeight: 400,
                        lineHeight: 1,
                        textAlign: 'center'
                    }}>ÚNETE A NUESTRA COMUNIDAD</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -2, justifyContent: 'center', px: 3}}>
                <Typography sx={{
                    fontSize: 16,
                    fontWeight: 300,
                    textAlign: 'center'
                }}>
                    <br/>
                    Suscríbete y recibe 10% OFF en tu primera compra
                </Typography>
            </Grid>

            <Grid container size={12}
                  sx={{
                      mt: sTab ? 8 : 4,
                      justifyContent: 'center',
                      mb: !masSM ? 8 : 0
                  }}>
                <Button
                    onClick={() => abrir()}
                    sx={{
                        px: 6
                    }}>SUSCRÍBETE</Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 10}}
                  sx={{justifyContent: 'center', mt: sCell ? -4 : 2, pb: sCell ? 0 : 0, px: 2 }}>
                <Typography sx={{
                    fontSize: 14,
                    fontWeight: 300,
                    textAlign: 'center'
                }}>
                    Al registrarte, aceptas nuestra <span
                    onClick={() => abrirPol({texto: politicas})}
                    style={{textDecoration: 'underline', cursor: 'pointer'}}>Política de Privacidad</span> y
                    autorizas el uso
                    de tus datos para recibir novedades, promociones y beneficios exclusivos.
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                <img src={img_fondo} width={'100%'} height={'auto'}/>
            </Grid>


        </Grid>
    )

}
export default Anuncio_Suscribite